import {USER,ROLES, MENU_TOGGLE, 
	INIT_GRID, MODULES,
	ISAUTHENTICATED,SIDEBARMENUS,
	DASHBOARDPUBS,DASHBOARDTAGS,DASHBOARDARTICLES
} from '../constant';

//auth
export function setUser(payload){
	return {type: USER, payload}
}
export function setRoles(payload){
	return {type: ROLES, payload}
}
export function setModules(payload){
	return {type: MODULES, payload}
}
export function setAuthenticated(payload){
	return {type: ISAUTHENTICATED, payload}
}
export function setMenuToggle(payload){
	return {type: MENU_TOGGLE, payload}
}

//sideBar Menus
export function setSidebarMenus(payload){
	return {type: SIDEBARMENUS, payload}
}

//dashboard
//dashboard
export function setDashboardPubs(payload){
	return {type: DASHBOARDPUBS, payload}
}
export function setDashboardTags(payload){
	return {type: DASHBOARDTAGS, payload}
}
export function setDashboardArticles(payload){
	return {type: DASHBOARDARTICLES, payload}
}


//grid
export function setInitGrid(payload){
	return {type: INIT_GRID, payload}
}